<template>
    <div>
        <!-- <div class="wrapper" id="wrapper" ref="wrapper" @mouseenter="onMouse" @mouseleave="onMouse">
            <div class="content">
                <ul class="honor" ref="honor" id="honor">
                    <li v-for="(item,index) in honorCredential" :key="item.honorId">
                        <img :src="item.imageUrl" :alt="item.honorId">
                    </li>
                </ul>
                <ul class="honor2" ref="honor2" id="honor2"></ul>
            </div>
        </div> -->
        <div class="example-3d" @mouseenter="onMouseenter" @mouseleave="onMouseleave">
            <swiper class="swiper" :options="swiperOption" ref="myBotSwiper">
                <swiper-slide class="swiperItem" v-for="(item,index) in honorCredential" :key="item.honorId">
                    <img :src="item.imageUrl" :alt="item.honorId">
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            timer: null,
            isScroll: true,
            honorCredential: [],
            swiperOption: {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: '4',
                loop: true,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                    reverseDirection: true
                },
                coverflowEffect: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true
                },
            }
        }
    },
    async created() {
        await this.getHonerList()
    },
    mounted() {
        // this.setLeft()
    },
    methods: {
        async getHonerList() {
            let data = {
                url: "http://MID-CLIENT-MALL/messageService/websiteService/queryHonorGallery",
                body: {}
            }
            this.honorCredential = await this.invoke(data)
        },
        onMouseenter() {
            this.$refs.myBotSwiper.$swiper.autoplay.stop();
        },
        onMouseleave() {
            this.$refs.myBotSwiper.$swiper.autoplay.start();
        }
        // scroll() {
        //     if (!this.isScroll) {
        //         return false;
        //     } else {
        //         let wrapper = this.$refs['wrapper'],
        //             honor = this.$refs['honor'],
        //             honor2 = this.$refs['honor2'];
        //         honor2.innerHTML = honor.innerHTML;
        //         if (wrapper.scrollLeft >= 7980)
        //             wrapper.scrollLeft = 0;
        //         wrapper.scrollLeft += 1;
        //     }
        // },
        // setLeft() {
        //     this.timer = setInterval(this.scroll, 10)
        // },
        // onMouse() {
        //     this.isScroll = !this.isScroll
        // },


    },
    // beforeDestroy() {
    //     this.isScroll = false;
    //     clearInterval(this.timer)
    // }

}
</script>

<style lang="scss" scoped>
.example-3d {
    width: 1064px;
    height: 188px;
    margin-top: 20px;
}
.swiper {
    height: 188px;
    width: 100%;
    .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 266px;
        height: 188px;
        background-color: #fff;
        .swiperItem {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
}
// 无缝轮播

.wrapper {
    width: 1064px;
    height: 188px;
    margin-top: 10px;
    overflow: hidden;
    cursor: pointer;
    //  box-shadow: 0px 0px 7px 4px #ccc;
    // overflow-x: scroll;
    .content {
        width: 9044px;
        height: 188px;
        .honor,
        .honor2 {
            width: 4522px;
            float: left;
            li {
                width: 266px;
                height: 188px;
                float: left;
                img {
                    // width: 226px;
                }
            }
        }
    }
}
</style>